import React from 'react';

const CompanyEmployeeCountFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M10.5781 17.107V16.7868C10.5804 15.8743 11.3193 15.1351 12.2315 15.1328H14.8456C15.7578 15.1351 16.4967 15.8743 16.499 16.7868V17.107V17.107C16.499 17.3252 16.3221 17.5021 16.104 17.5021H10.9723C10.7545 17.5017 10.5781 17.3249 10.5781 17.107V17.107Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.5372 13.1583C12.6656 13.1567 11.9601 12.4493 11.9609 11.5777C11.9617 10.7061 12.6685 10 13.5401 10C14.4117 10 15.1185 10.7061 15.1193 11.5777C15.1201 12.4493 14.4146 13.1567 13.543 13.1583H13.5372Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CompanyEmployeeCountFilterIcon;
